import CodeLine from "../CodeLine/CodeLine";
import "./About.scss";

export default function Description() {
  const description = [
    "/**",
    " * Full Stack Developer",
    " * Sotunec Saraya",
    " * Tunis, Tunisia",
    " * May 2026 - Present",
    " * ",
    " * Built SoBeam, a ThingsBoard IoT platform managing data for over 3,000 devices.",
    " * Created full-stack apps for Water and Energy Meters, and Public Lighting.",
    " * Developed Spring Boot APIs and user interfaces to display live IoT data.",
    " * Set up data pipelines, custom dashboards, and automated alerts.",
    " * Applied strict security and data protection in accordance with ISO 27001 standards.",
    " * Improved system performance and reliability using logging and performance tools.",
    " */",
  ];

  return (
    <div className="description-layout">
      <div className="description-layout__desktop">
        {description.map((line, idx) => (
          <CodeLine
            key={idx}
            lineNumber={idx + 1}
            words={[{ text: line, class: "comment" }]}
          />
        ))}
      </div>

      <div className="description-layout__mobile">
        Full Stack Developer at Sotunec Saraya (Tunis, Tunisia). Built SoBeam, a ThingsBoard 
        IoT platform managing data for over 3,000 devices, and created full-stack apps for 
        Water and Energy Meters, and Public Lighting. Developed Spring Boot APIs and user 
        interfaces, set up data pipelines, custom dashboards, and automated alerts. Applied 
        strict security per ISO 27001 and improved system performance.
      </div>
    </div>
  );
}
